export class TaxUtilities {
  /**
   * Calculated and returns the net value from a given gross value and tax
   * @param gross The gross value
   * @param tax The tax applied in decimal, i.e., 0.2 for 20%
   * @return The calculated net value
   */
  static getNetFromGross(gross: number, tax: number): number {
    return gross / (1 + tax);
  }

  /**
   * Calculates and returns the gross value from a given net value and tax
   * @param net The net value
   * @param tax The tax applied in decimal, i.e., 0.2 for 20%
   * @return The calculated gross value
   */
  static getGrossFromNet(net: number, tax: number): number {
    return net * (1 + tax);
  }

  /**
   * Calculates and returns the tax rate from given gross and net values
   * @param gross The gross value
   * @param net The net value
   * @return The calculated tax rate in decimal, i.e., 0.2 for 20%
   */
  static getTaxRateFromGrossAndNet(gross: number, net: number): number {
    return (gross) / net - 1;
  }

  /**
   * Calculates and returns the profit margin from a given total revenue and total costs
   * @param totalRevenue The total revenue
   * @param totalCosts The total costs
   * @return The calculated profit margin in decimal, i.e., 0.2 for 20%. If total cost is zero, returns 1
   */
  static calculateMargin(totalRevenue: number, totalCosts: number): number {
    if (totalCosts === 0)
      return 1;
    return (totalRevenue - totalCosts) / totalRevenue;
  }

}
